import { render, staticRenderFns } from "./StoreGoodsAdd.vue?vue&type=template&id=c70de0d0&scoped=true"
import script from "./StoreGoodsAdd.vue?vue&type=script&lang=js"
export * from "./StoreGoodsAdd.vue?vue&type=script&lang=js"
import style0 from "./StoreGoodsAdd.vue?vue&type=style&index=0&id=c70de0d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70de0d0",
  null
  
)

export default component.exports